import { Pipe, PipeTransform } from '@angular/core';
import { angularNumberFilter } from 'apps/account/src/account-shared/pipes/angular-number-format.util';
import { parseValue } from 'apps/account/src/account-shared/pipes/parse-value.util';

/**
 * Local standalone pipes — native verbatim ports of the AngularJS `$filter('number'|'percentage')`
 * the FROZEN baseline renders the cooperative big-picture stats with. `number` → `angularNumberFilter`
 * (verbatim AngularJS en-US numberFilter, so `| number` / `| number:2` match character-for-character);
 * `percentage` → v1 calculate.js (`intOrDefault(value)/intOrDefault(total)*100`, NaN→0) via `parseValue`.
 * Off the `$filter` bridge — proven 0/279 by account-parity/_diag-number-check.mjs.
 * Kept LOCAL + standalone (barrel-free), same rule as the contest-sheets pipes
 * ([[project_account_barrel_eval_order_fragility]]).
 */
@Pipe({ name: 'number' })
export class CoopNumberPipe implements PipeTransform {
  transform(value: any, fractionSize?: any): any {
    return angularNumberFilter(value, fractionSize);
  }
}

@Pipe({ name: 'percentage' })
export class CoopPercentagePipe implements PipeTransform {
  transform(value: any, total?: any): any {
    const percentage = (parseValue(value, 'number') / parseValue(total, 'number')) * 100;
    return isNaN(percentage) ? 0 : percentage;
  }
}
